import { DEFAULT_CUSTOMER_TYPE } from '../../../constants/defaultCustomerType'
import { PredefinedCustomerValues } from '../../../types/predefinedCustomerValues'

export const getEInvoicingAddressFormDefaultValues = (predefinedCustomerValues?: PredefinedCustomerValues) => {
  const { customerType, ...customerValues } = predefinedCustomerValues || {}

  return {
    addressingLine: undefined,
    customerType: customerType ?? DEFAULT_CUSTOMER_TYPE,
    ...customerValues,
  }
}
